import { UpdateUserAdapters } from '../adapters';
import { updateUser } from '../clients/UpdateUser';
import { UpdateUserApiError } from '../errors';
import type { IUpdateUserRequest } from '../types/UpdateUser';

const updateUserDomain = async (input: IUpdateUserRequest): Promise<void> => {
  try {
    await updateUser(UpdateUserAdapters.toApiPayload(input));
  } catch (error) {
    const typedError = UpdateUserApiError.fromAxiosError(error);
    throw typedError ?? error;
  }
};

export const UpdateUserService = {
  updateUser: updateUserDomain,
};
